import { render, staticRenderFns } from "./ToolsPrefectToast.vue?vue&type=template&id=4d18f036&scoped=true"
import script from "./ToolsPrefectToast.vue?vue&type=script&lang=js"
export * from "./ToolsPrefectToast.vue?vue&type=script&lang=js"
import style0 from "./ToolsPrefectToast.vue?vue&type=style&index=0&id=4d18f036&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d18f036",
  null
  
)

export default component.exports